import { apiFetch } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const trainings = createWorkspaceResourceApi('trainings')
const multipart = { 'Content-Type': 'multipart/form-data' }

const post = (url, body, headers) => apiFetch(url, { method: 'POST', body, headers })

export const trainingsApi = {
  list: trainings.list,
  get: trainings.get,
  remove: trainings.remove,
  assignedUsers: (workspaceId, id, params) =>
    apiFetch(`${trainings.path(workspaceId)}/${id}/assigned-users`, { params }),
  resendInvitation: (workspaceId, assignmentId) =>
    post(`${trainings.path(workspaceId)}/assigned-users/${assignmentId}/resend-invitation`),
  create: (workspaceId, payload) => post(trainings.path(workspaceId), payload, multipart),
  generate: (workspaceId, payload) => post(`${trainings.path(workspaceId)}/generate`, payload, multipart),
  // Laravel method spoofing, kept as the backend expects it.
  update: (workspaceId, id, payload) =>
    post(`${trainings.path(workspaceId)}/${id}`, { ...payload, _method: 'PUT' }, multipart),
  assign: (workspaceId, payload) => post(`${trainings.path(workspaceId)}/assign`, payload, multipart),
  answerFromFile: (workspaceId, formData) =>
    post(`${trainings.path(workspaceId)}/answer-from-file`, formData, multipart),
  generatePresentation: (workspaceId, formData) =>
    post(`${trainings.path(workspaceId)}/generate-presentation`, formData, multipart),
  generateReport: (workspaceId, id, formData) =>
    post(`${trainings.path(workspaceId)}/${id}/report`, formData, multipart),

  // Learner-facing quiz (not workspace-scoped)
  quiz: (trainingId, { signal } = {}) => apiFetch(`training/${trainingId}`, { signal }),
  result: (trainingId, { signal } = {}) => apiFetch(`training/${trainingId}/result`, { signal }),
  acknowledge: (trainingId) => post(`training/${trainingId}/acknowledge`),
  submitQuiz: (trainingId, payload) => post(`training/${trainingId}/quiz/submit`, payload),
}
